import { Metamodel } from 'app/model/base/model';
import { Named } from 'app/model/base/named';
import { IModel, IAttribute } from 'app/model/base/annotation';


@Metamodel.model({
    abstract: true
})

export abstract class FormatWriteSettings extends Named {
    public static readonly MODEL: IModel;
    public static readonly MAXROWS_PER_FILE: IAttribute;
    public static readonly FILENAME_PREFIX: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'MAXROWS_PER_FILE',
        display: stringResources.ModelName_MaxRowsPerFileLabel
    })
    public maxRowsPerFile?: number;

    @Metamodel.attribute({
        templatable: true,
        association: 'FILENAME_PREFIX',
        display: `${stringResources.FileNameLabel} ${stringResources.Prefix.toLocaleLowerCase()}`
    })
    public fileNamePrefix?: string;

    public recoverPropFromPrevOne(prevStoreSettings: FormatWriteSettings): void {
        if (prevStoreSettings?.fileNamePrefix != null) {
            this.fileNamePrefix = prevStoreSettings?.fileNamePrefix;
        }
        if (prevStoreSettings?.maxRowsPerFile != null) {
            this.maxRowsPerFile = prevStoreSettings?.maxRowsPerFile;
        }
    }
}
